/* eslint-disable import/prefer-default-export */
import { MARKS } from '../../constants/language';

export const insertCaret = (p, idx) =>
  `${p.slice(0, idx)}${MARKS.caret}${p.slice(idx)}`;
